
import {
  Vue, Component, Ref, Watch,
} from 'vue-property-decorator'
import Widget from '@/components/Widget/Widget.vue'
import ViewModel from '@/models/ViewModel'
import IconAction from '@/components/IconAction/IconAction.vue'
import SearchInput from '@/components/SearchInput/SearchInput.vue'
import DataTable from '@/components/DataTable/index.vue'
import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import RowToggle from '@/components/RowToggle/RowToggle.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import CheckboxInput from '@/components/CheckboxInput/index.vue'
import MediaProperty from '@/models/MediaProperty'
import fields from './fields'

@Component({
  components: {
    Widget,
    IconAction,
    SearchInput,
    DataTable,
    RowToggle,
    FormInput,
    CheckboxInput,
  },
})
export default class MediaPropertyHome extends ViewModel {
  @Ref() readonly dataTable!: HTMLFormElement

  public media_property: MediaProperty = new MediaProperty()

  public modal: boolean = false

  public records: number = 0

  public loading: boolean = false

  public ready = false

  public query: string[] = []

  public selected: string[] = []

  public logos: string[] = []

  public fieldFilters: any = {}

  public fields: Array<any> = []

  public show_filter_helper: boolean = false

  public get show_fields() {
    return this.fields.filter((f: any) => f.show)
  }

  public filter_mode: string = 'exclusive'

  @Watch('filter_mode')
  public onFilterModeChange() {
    this.refresh()
  }

  public get options() {
    return {
      query_settings: {
        custom_fields: [
          {
            name: 'has:no_group_name',
            value: 'has:no_group_name',
            description: 'Records without a group name',
          },
          {
            name: 'has:no_logo',
            value: 'has:no_logo',
            description: 'Records without a logo',
          },
        ],
      },
    }
  }

  public rows(context: any) {
    this.loading = true
    const field_filters = Object.keys(this.fieldFilters)
      .filter((key: string) => this.fieldFilters[key] !== '')
      .map((key: string) => `${key}:${this.fieldFilters[key].toLowerCase()}`)
    this.syncFilters()
    return MediaProperty.paginate({
      page_size: context.perPage,
      page: context.currentPage,
      order_by: context.sortBy,
      order: context.sortDesc ? 'desc' : 'asc',
      query: [...context.filter, ...field_filters],
      mode: this.filter_mode,
    }).then(result => {
      this.records = result.records
      this.loading = false
      return result.data
    })
  }

  public editMediaProperty(media_property: MediaProperty) {
    this.$router.push(`/app/media_property/${media_property.id}`)
  }

  public refresh() {
    this.dataTable.refresh()
  }

  public resetFilters() {
    this.fieldFilters = {}
    this.query = []
    this.clearFilters()
    this.refresh()
  }

  public mounted() {
    this.fields = fields
    this.loadFilters()
  }

  public syncFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'media_property',
      data: { query: this.query, fieldFilters: this.fieldFilters },
    })
  }

  public loadFilters() {
    const system = getModule(SystemtModule)
    system.getFilter('media_property').then((filter: any) => {
      if (filter) {
        this.query = filter.query
        this.fieldFilters = filter.fieldFilters
      }
      this.ready = true
    })
  }

  public clearFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'media_property',
      data: null,
    })
  }
}
